// source: PreGeneratedValueOutputs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs', null, global);
goog.exportSymbol('proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor', null, global);
goog.exportSymbol('proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.repeatedFields_, null);
};
goog.inherits(proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.displayName = 'proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.displayName = 'proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.displayName = 'proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.toObject = function(opt_includeInstance) {
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.toObject = function(includeInstance, msg) {
  var f, obj = {
    safewithdrawalratesList: jspb.Message.toObjectList(msg.getSafewithdrawalratesList(),
    proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.toObject, includeInstance),
    whatiffactorsList: jspb.Message.toObjectList(msg.getWhatiffactorsList(),
    proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs;
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate;
      reader.readMessage(value,proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.deserializeBinaryFromReader);
      msg.addSafewithdrawalrates(value);
      break;
    case 2:
      var value = new proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor;
      reader.readMessage(value,proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.deserializeBinaryFromReader);
      msg.addWhatiffactors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSafewithdrawalratesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.serializeBinaryToWriter
    );
  }
  f = message.getWhatiffactorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.toObject = function(opt_includeInstance) {
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetallocation: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate;
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetallocation(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetallocation();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string AssetAllocation = 1;
 * @return {string}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.getAssetallocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.setAssetallocation = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double Rate = 2;
 * @return {number}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate.prototype.setRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.toObject = function(opt_includeInstance) {
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.toObject = function(includeInstance, msg) {
  var f, obj = {
    strategy: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor;
  return proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStrategy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string Strategy = 1;
 * @return {string}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.getStrategy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.setStrategy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double Amount = 2;
 * @return {number}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated SafeWithdrawalRate SafeWithdrawalRates = 1;
 * @return {!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate>}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.getSafewithdrawalratesList = function() {
  return /** @type{!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate, 1));
};


/**
 * @param {!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate>} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} returns this
*/
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.setSafewithdrawalratesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.addSafewithdrawalrates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.SafeWithdrawalRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.clearSafewithdrawalratesList = function() {
  return this.setSafewithdrawalratesList([]);
};


/**
 * repeated FumChangeFactor WhatIfFactors = 2;
 * @return {!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor>}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.getWhatiffactorsList = function() {
  return /** @type{!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor, 2));
};


/**
 * @param {!Array<!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor>} value
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} returns this
*/
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.setWhatiffactorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor}
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.addWhatiffactors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.FumChangeFactor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs} returns this
 */
proto.SmartShield.Api.Output.V100.PreGeneratedValueOutputs.prototype.clearWhatiffactorsList = function() {
  return this.setWhatiffactorsList([]);
};


goog.object.extend(exports, proto.SmartShield.Api.Output.V100);
